import api from "../ApiConfig";
import { Apis } from "../../config";
import { NotificationManager } from "react-notifications";
import unauthService from "../unauth";

// DELETE NOTIFICATION
const DeleteNotification = async (id) => {
  try {
    const result = await api.delete(`${Apis.GetAllNotificationPath}?id=${id}`, {
      headers: { "Content-Type": "application/json" },
    });

    if (result.data?.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    const parsedData = JSON.parse(result.data);
    NotificationManager.success(
      parsedData.message || "Deleted successfully",
      "Success"
    );
    return parsedData;
  } catch (error) {
    if (error?.response?.status === 401) {
      unauthService();
    }
    console.error("Error in DeleteNotification:", error);
    NotificationManager.error(
      "An error occurred while deleting the notification."
    );
    return null;
  }
};

const markAsComplete = async (id) => {
  console.log(" marking id--", id);
  try {
    const result = await api.put(
      `${Apis.GetAllNotificationPath}/markAsComplete?id=${id}`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (result.data?.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    const parsedData = JSON.parse(result.data);
    NotificationManager.success(
      parsedData.message || "Marked as complete successfully",
      "Success"
    );
    return parsedData;
  } catch (error) {
    if (error?.response?.status === 401) {
      unauthService();
    }
    console.error("Error in DeleteNotification:", error);
    NotificationManager.error("An error occurred while Marking as complete.");
    return null;
  }
};

// GET ALL NOTIFICATIONS
const GetAllNotification = async (
  userId,
  { fromDate = "", toDate = "", page = 1, limit = 5 } = {}
) => {
  try {
    const params = new URLSearchParams({
      userId,
      fromDate,
      toDate,
      page,
      limit,
    }).toString();

    const result = await api.get(`${Apis.GetAllNotificationPath}?${params}`, {
      headers: { "Content-Type": "application/json" },
    });

    const parsedData = JSON.parse(result.data);
    const response = JSON.parse(parsedData.body || "{}");

    if (parsedData?.error) {
      NotificationManager.error(parsedData.error);
      return null;
    }

    return response?.additionalData || { notifications: [], total: 0 };
  } catch (error) {
    if (error?.response?.status === 401) {
      unauthService();
    }
    console.error("Error in GetAllNotification:", error);
    NotificationManager.error(
      "An error occurred while fetching notifications."
    );
    return null;
  }
};

const markNotificationAsSeen = async (notificationId, userId) => {
  try {
    const params = new URLSearchParams({
      notificationId,
      userId,
    }).toString();

    const result = await api.put(
      `${Apis.markAsRead}?${params}`,
      {},
      {
        headers: { "Content-Type": "application/json" },
      }
    );

    if (result.data?.error) {
      NotificationManager.error(result.data.error);
      return null;
    }

    const parsedData = JSON.parse(result.data);
    return parsedData;
  } catch (error) {
    if (error?.response?.status === 401) {
      unauthService();
    }
    console.error("Error in markNotificationAsSeen:", error);
    NotificationManager.error(
      "An error occurred while marking notification as seen."
    );
    return null;
  }
};

export default {
  DeleteNotification,
  GetAllNotification,
  markAsComplete,
  markNotificationAsSeen,
};
